import React, { Component } from 'react';
import { Dropdown as BsDropdown } from 'react-bootstrap';
import makeBranch from './makeBranch';
import DropdownMenu from './DropdownMenu';
import DropdownToggle from './DropdownToggle';

/**
 * Temporary component for Dropdown.
 */
class Dropdown extends Component {
  render() {
    return <div>Work in progress lol</div>;
  }
}

const DropdownBranch = makeBranch('DropdownBranch', BsDropdown, Dropdown);

DropdownBranch.Toggle = DropdownToggle;
DropdownBranch.Menu = DropdownMenu;

export default DropdownBranch;
